export default {"src":"/_next/static/image/public/images/download_app_banner_bg.1a30288918a9322499fa4a76815f78f7.svg","height":188,"width":1112};